module.exports = __webpack_public_path__ + "img/level_four.1229caed.png";